import { createSlice } from "@reduxjs/toolkit";

export const signalRHubSlice = createSlice({
  name: "signalRConnections",
  initialState: {},

  reducers: {
    setSignalRConnectionStatus: (state, action) => {
      let data = action.payload;
      state[data.hubName] = action.payload.status;
    },
  },
});
export const { setSignalRConnectionStatus } = signalRHubSlice.actions;

export const getSignalRConnections = (state) => {
  return state.signalRConnections;
};
export const getSignalRConnectionStatus =
  (key = "") =>
  (state) => {
    return state.signalRConnections[key];
  };

export default signalRHubSlice.reducer;
